import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';

const useDisclaimerParams = (payment, trim, language) => {
  const {
    freightPdi,
    ppsaRegistrationFee,
    registeringAgentFee,
    costOfBorrowing,
    dateFrom,
    dateTo,
    downPayment,
    financeApr,
    weeklyPaymentAmt,
    months,
    weeklyPayments,
  } = payment?.disclaimerFields || {};
  const totalAmount = payment?.netPaymentAmount || payment?.msrp;
  const numericCostOfBorrowing = parseFloat(String(costOfBorrowing).replace(/[^\d.]/g, '')) || 0;
  const numericTotalAmount = parseFloat(String(totalAmount).replace(/[^\d.]/g, '')) || 0;
  const numericTotalObligation = numericCostOfBorrowing + numericTotalAmount;
  const formatPriceValue = value => formatPrice(value || 0, language, 2);
  return {
    dateFrom,
    dateTo,
    modelYear: trim?.modelYear,
    modelName: trim?.name,
    sellingPrice: totalAmount,
    msrp: totalAmount,
    freight: formatPriceValue(freightPdi),
    registrationFee: formatPriceValue(ppsaRegistrationFee),
    registeringFee: formatPriceValue(registeringAgentFee),
    downPayment: formatPriceValue(downPayment),
    financeApr,
    weeklyPaymentAmt,
    months,
    weeklyPayments,
    costOfBorrowing: formatPriceValue(costOfBorrowing),
    totalObligation: formatPriceValue(numericTotalObligation),
  };
};

export default useDisclaimerParams;
